

















import { Component, Mixins, Watch } from 'vue-property-decorator'
import { HistoryViewMixin } from '@/mixins'
import { Track } from '@/classes/track'
import { IColumnHeader, TrackFields } from '@/constants'
import { IColumnDef } from '@/interfaces/ag-grid'

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default
  }
})
export default class Reorder extends Mixins(HistoryViewMixin) {
  columns: IColumnHeader[] = []
  tracks: Track[] = this.$store.getters['library/selectedTracks']

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title,
      rowDrag: true
    },
    {
      field: TrackFields.Artist
    }
  ]

  async next() {
    this.$store.commit('library/setSelectedTracksByTrack', this.tracks)

    await this.$router.push({
      name: 'export to file download'
    })
  }

  async created() {
    if (this.tracks.length === 0) {
      await this.$router.replace({
        name: 'export to file'
      })
    }
  }

  @Watch('columns')
  watchColumns() {
    this.$store.commit('exporttofile/setColumns', this.columns)
  }
}
